module.exports = __webpack_public_path__ + "img/sba-full-suite-of-sba-programs.d50a608.png";